import { customType } from 'drizzle-orm/pg-core'

// Custom numeric type that returns number
export const numericAsNumber = customType<{ data: number; driverData: string }>({
  dataType() {
    return 'numeric(12, 2)' // 12 total digits, 2 decimal places
  },
  fromDriver(value: string): number {
    return parseFloat(value)
  },
  toDriver(value: number): string {
    return value.toString()
  },
})
